import React from "react";
import "./Users.scss";
import { Grid } from "@material-ui/core";
import { SVG } from "sunrise-ui";
import { Theme, createStyles } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import Backdrop from "@material-ui/core/Backdrop";
import Fade from "@material-ui/core/Fade";

const useStylesForModal = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      border: "1px solid #5f67e0",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(1, 1, 1),
    },
  })
);

const EnlargeImage = ({ modalData }: { modalData: any }) => {
  const modalClasses = useStylesForModal();
  const [openImage, setOpenImage] = React.useState(false);
  const [modalImg, setModalImg] = React.useState("");
  const handleClose = () => {
    setOpenImage(false);
    setModalImg("");
  };
  React.useEffect(() => {
    setOpenImage(modalData.isOpen);
    setModalImg(modalData.image);
  }, [modalData]);
  return (
    <Grid>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={modalClasses.modal}
        open={openImage}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openImage}>
          <div className={modalClasses.paper}>
            <div className="relative">
              <div
                className="close_icon pointer d-flex h-center v-center"
                onClick={handleClose}
              >
                <SVG type={"close"} />
              </div>
              <img src={modalImg} alt="..." className="modal_popup_img" />
            </div>
          </div>
        </Fade>
      </Modal>
    </Grid>
  );
};

export default EnlargeImage;
